import { Component, Vue } from "vue-property-decorator";

import { IRmaAttributeName, IRmaModel } from "../../../models/rma.model";
import PazAttributesDialog from "../../../components/dialog/PazOrderAttributeDialog.vue";
import AttributesTab from "../../../components/dialog/tabs/AttributesTab.vue";
import { getReturnsAttributes } from "../../../services/catalog-service";

@Component({
  components: {
    PazAttributesDialog,
    AttributesTab,
  },
})
export default class RmaAttributesMixin extends Vue {
  public rmaAttributeNames: IRmaAttributeName[] = [];
  public showAttributesModal: boolean = false;

  async showAttributeModal(rma: IRmaModel) {
    this.selectedRma = rma;
    this.showAttributesModal = true;
    this.rmaAttributeNames = await getReturnsAttributes();
  }

  getAttributesCount(rma: IRmaModel) {
    return rma.attributeValue && rma.attributeValue.length > 0
      ? rma.attributeValue.length
      : false;
  }
} 
